/**************************表单发起集合api **************************/
import { isCardID, isCardIDTwo } from './utils.js'
import { numberCardType, normalType } from '@/components/fromDesigner/compon/regularFrom/fileRegular.js'
import { formatDate } from './global.js'
//关联单选
// export const associatedControls = ((appArr) => {
// });

//选择框格式转换
export function objSels (item) {
  if (typeof (item) == "string") {
    return JSON.parse(item)
  } else {
    return item
  }
}
/**
 * 校验数据
 * date 模板数据
 * formdata 值数据
 * othersObj 单选-其他
 * modifyId 是否修改
 * associationVisible 关联单选，验证隐藏(如果是隐藏就不验证)
 * **/
export function ruleListChilDcheckData ({ date, formdata, othersObj, modifyId, associationVisible, isBatch = false }) {
  console.log('提交验证', date, formdata, othersObj, modifyId, associationVisible, isBatch)
  let dates = JSON.parse(JSON.stringify(date));
  let whetherDetail = false;
  //- 明细，新版关联选择选择指定到list
  if (date.type === 'details' || date.type === 'new-rel-radio') {
    date = dates.list;
    whetherDetail = true;
  }

  let astvblom = true;//隐藏显示，如果为true就是需要验证，提交数据，false就是不要验证
  if (Array.isArray(date)) {
    for (let i in date) {
      const item = date[i];
      // 始终隐藏的话直接忽略过当前所有判断
      if (item.viewHide) continue;
      // 明细控件-开启用户控制填写，并且客户端关闭填写，则隐藏明细并忽略所有判断
      if (item.type == 'details' && item.fill && item.fill.switch && !formdata[item.title + '_fillStatus']) continue;
      if (associationVisible && i > associationVisible.key && associationVisible.key != -1) {//-2为关联单选进来
        astvblom = associationVisible.value[item.title + '_' + item.type]
      }
      console.log("astvblom==>", astvblom)
      // 忽略 label
      if (item.type === 'label') continue;

      let types = item.title + '_' + item.type;

      // 删除特定值
      if (item.valbindinf) delete item.valbindinf;
      
      //- 是否明细判断处理
      if (item.type !== 'details') {
        //- 非明细控件
        //- 身份证格式验证
        if (item.per !== 2 && item.per !== 3 && item.idCardValid && ((item.required !== 'required' && formdata[types]) || item.required === 'required' && astvblom)) {
          if (formdata[types] && formdata[types].length === 18) {
            let card = isCardID(formdata[types]);
            if (card !== true) {
              item.cardText = card;
              return item;
            }
          } else {
            if (!isCardIDTwo(formdata[types])) {
              item.cardText = '身份证信息不正确';
              return item;
            }
          }
        }
        //- 正则判断
        //- 文本控件新增正则判断显示

        if (item.per == 1 || !item.per) {
          //- 填写模式，修改模式
          if (item.regularObj && item.regularObj.val === true && item.type == 'text' && astvblom) {
            //- 说明该文本控件有设置正则效验
            let regularObjSetting = item.regularObj.setting;
            if (regularObjSetting.region === 1) {
              //- 常规效验

              let findIdx = normalType.rules.findIndex((findItem) => {
                return findItem.id === regularObjSetting.rulesVal
              })
              let values = formdata[types];
              if (findIdx != -1 && values) {
                let rules = eval(normalType.rules[findIdx].val);

                if (!(rules.test(values))) {
                  //- 常规效验失败
                  item.errormsg = normalType.rules[findIdx].msg
                  return item;
                }
              }

            } else {
              //- 身份证验证
              let formVal = formdata[regularObjSetting.rulesVal];
              let values = formdata[types];

              let findIdx = numberCardType.rules.findIndex((findItem) => {
                return findItem.name === formVal

              })

              if (formVal && values && findIdx != -1) {
                if (numberCardType.rules[findIdx].name === '中国居民身份证') {
                  //- 产品改需求，身份证需要严格处理
                  let whether = isCardID(values)
                  if (whether !== true) {
                    item.errormsg = whetherDetail === true ? '明细:' + numberCardType.rules[findIdx].msg : numberCardType.rules[findIdx].msg
                    return item;
                  }
                } else {
                  let rules = eval(numberCardType.rules[findIdx].val);
                  if (!(rules.test(values))) {
                    //- 身份证效验失败
                    item.errormsg = whetherDetail === true ? '明细:' + numberCardType.rules[findIdx].msg : numberCardType.rules[findIdx].msg
                    return item;


                  }

                }

              }

            }
          }

        }


        if (item.per !== 2 && item.per !== 3 && astvblom) {
          //if (!modifyId) {
            //- 修改也需要验证（2023.11.30 国贸需求，欧总说统一修改）
            //- 最大最小必填
            console.log('提交验证1', types, formdata)
            if (item.miniunm !== 0 && item.miniunm !== '-Infinity' && formdata[types] && formdata[types].length < item.miniunm || item.miniunm && item.miniunm !== 0 && item.miniunm !== '-Infinity' && !formdata[types]) {
              const obj = {...item}
              obj.valbindinf = !formdata[types] ? 0 : formdata[types].length;
              return obj;
            }
            if (item.sizeLimit && item.sizeLimit !== 0 && item.sizeLimit !== 'Infinity' && formdata[types] && formdata[types].length > item.sizeLimit) {
              const obj = {...item}
              obj.valbindinf = formdata[types].length;
              return obj;
            }
            // 单选-其他(必填) othersObj 是数组的话就是明细里面（批量里面不验证他）
            if (item.type === 'radio' && item.others && formdata[types] === 'others其他' && !isBatch) {
              if (dates.type === 'details' || dates.type === 'new-rel-radio') {
                if (othersObj[types] === '') return item;
              } else {
                if (item.othersVal === '') return item;
              }
            }
          //}
          //- 如果是数字，并且配置了数字可输入范围
          if (item.type == 'number' && (item.max || item.min) && (formdata[types] || formdata[types] == 0)) {

            if ((item.max && formdata[types] > item.max) || (item.min && formdata[types] < item.min)) {
              item.errormsg = `${item.name}的输入范围必须${item.max && item.min ? "在" + item.min + "-" + item.max + "之间" : item.max ? '不大于' + item.max : '不小于' + item.min}`
              return item
            } else {
              delete item.errormsg
            }
          }
        }
        //必填
        if (Number(item.per) !== 3 && Number(item.per) !== 2 && item.type !== 'label' && item.required === 'required' && astvblom) {
          // 符合条件，进行处理
          // 如果当前值为 0 也放过去
          if (!formdata[types] && formdata[types] !== 0 || formdata[types] && formdata[types].length === 0 || formdata[types] instanceof String === true && formdata[types].match(/^[ ]*$/)) {
            return item;
          }
        } else {
          
          
          // 条件不符合
        }
        if (item.type === 'richTextWid' && item.required && item.required === 'required' && (formdata[types] === item.bindinf || !stripHTMLTags(formdata[types]))) {
          return item;
        }
        if (item.list && item.list.length > 0 && item.type !== 'relation-check') {
          let isChecks = null;
          // 关联单选的是放出来的所以另外处理
          if (item.type === 'new-rel-radio') {
            isChecks = astvblom ? ruleListChilDcheckData({
              date: item,
              formdata: formdata,
              othersObj: othersObj,
              modifyId: modifyId,
              associationVisible: associationVisible && associationVisible.key !== -1 ? { key: -2, value: associationVisible.value } : { key: -1 }
            }) : {};
          } else if (item.type === 'ready-widget') {
            isChecks = ruleListChilDcheckData({
              date: item.list,
              formdata: formdata[types][0],
              othersObj: othersObj, modifyId,
            });
          } else {
            isChecks = ruleListChilDcheckData({
              date: item.list,
              formdata: formdata[types],
              othersObj: othersObj, modifyId,
            });
          }
          if (isChecks.name) {
            return isChecks;
          }
        }
        // 预约控件验证当前预约时间段是否合理(主要验证预约时间段)
        if (item.type === 'ready-widget') {
          const value = formdata[types][0]
          const t = item.list[2].title + '_' + item.list[2].type
          const t1 = item.list[1].title + '_' + item.list[1].type
          if (!value[t] || value[t].length === 0) {
            return item.list[2]
          }
          const v1 = new Date(value[t1][0]).getTime()
          const v2 = new Date(value[t1][1]).getTime()
          const x = ((v2 - v1) / (24 * 3600 * 1000)) + 1
          const yObj = {}
          for (const s of value[t]) {
            if (s.time && s.time.length === 0) {
              item.list[2].errormsg = item.list[2].name + s.date + '不能为空!'
              return item.list[2]
            }
            yObj[s.date] = true
          }
          if (x !== Object.keys(yObj).length && !item.continuousMode) {
            for (let ie = 0; ie < x; ie++) {
              const stim = v1 + ((24 * 3600 * 1000) * ie)
              const sttim = formatDate(new Date(stim), "yyyy-MM-dd")
              if (!yObj[sttim]) {
                item.list[2].errormsg = item.list[2].name + sttim + '不能为空!'
                break
              }
            }
            return item.list[2]
          }
        }
      } else {
        //- 明细控件
        if (item.list && Array.isArray(item.list) && astvblom) {
          let is = {};
          if (formdata[types] && formdata[types].length > 0) {
            for (let arr = 0; arr < formdata[types].length; arr++) {
              let isChecks = ruleListChilDcheckData({
                date: item,
                formdata: formdata[types][arr],
                othersObj: othersObj && othersObj[types] && othersObj[types][arr] ? othersObj[types][arr] : [],
                modifyId: modifyId
              });
              if (isChecks.name) {
                // 明细错误具体到行
                isChecks.errorRow = arr + 1;
                isChecks.errorTitle = item.name;
                is = isChecks;
                return isChecks;
              }
            }
          }
          if (is.name) {
            return is;
          }
        }
      }
    }
  }
  return {};
}
function stripHTMLTags (str) {
  const whitelist = ['img']; // 允许保留的标签
  const pattern = new RegExp(`<(?!\\/?(${whitelist.join('|')})\\b)[^>]*>`, 'gi');
  return str.replace(pattern, '');
}
//图片附件上传和删除
export const imageFileOperationFunc = {
};

//隐藏显示格式处理
export function associationVisibleMassaging (associationVisible) {
  if (!associationVisible) {
    return { key: -1, value: {} };
  }
  let associationVal = { key: associationVisible.key, value: {} }
  for (let i in associationVisible.select) {
    try {
      let avs = JSON.parse(JSON.stringify(associationVisible.select[i][associationVisible.value[i]]))
      for (let b in avs) {
        associationVal.value[b] = associationVal.value[b] || avs[b]
      }
    }
    catch (error) { console.log('位置跳转错误') }
  }
  return associationVal;
}

// 标题显示查询
export function getFromLabel (item) {
  return !item.labelConfig || !item.labelConfig.isNameShow ? item.labelConfig && item.labelConfig.showName || item.name : ''
}

// 控件背景查询
export function getLabelBackk (item) {
  return item.labelConfig && item.labelConfig.labelBack ? {backgroundColor: item.labelConfig.labelBack} : ''
}

// 容器控件背景+宽度查询
export function getLabelConBackk (item) {
  return item.labelConfig && item.labelConfig.labelBack ? {backgroundColor: item.labelConfig.labelBack, width: item.width} : ''
}